import moment from "moment";

/**
 * @param languages - the list of languages to filter
 * @param item - the state item that include the languages
 * @param index
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to filter the languages before send it to the autocomplete
 */
export const getNotSelectedLanguage = (languages, item, index) => (languages || []).filter(
    (element) => Object.keys(item || {}).findIndex(
        (el, itemIndex) => el && el === element.code && index !== itemIndex,
    ) === -1,
);

/**
 * @param languages - the list of languages to filter
 * @param languageCode
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to get language title
 */
export const getLanguageTitle = (languages, languageCode) => languages.find((item) => languageCode === item.code)?.title || 'N/A';

/**
 * @param startDate - the starting date
 * @param daysToAdd - the number of business days to add
 * @author System
 * @Description this method calculates business days (excluding Friday and Saturday) from a start date
 */
export const addBusinessDays = (startDate, daysToAdd) => {
  let currentDate = moment(startDate);
  let businessDaysAdded = 0;
  
  while (businessDaysAdded < daysToAdd) {
    currentDate.add(1, 'day');
    // Check if it's a business day (Sunday = 0, Thursday = 4)
    const dayOfWeek = currentDate.day();
    if (dayOfWeek !== 5 && dayOfWeek !== 6) {
      // Not Friday or Saturday
      businessDaysAdded++;
    }
  }
  
  return currentDate;
};
